import { render, staticRenderFns } from "./FormAgenda.vue?vue&type=template&id=240e4b05&"
import script from "./FormAgenda.vue?vue&type=script&lang=js&"
export * from "./FormAgenda.vue?vue&type=script&lang=js&"
import style0 from "./FormAgenda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports